import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Icon from '../components/appIcon';
import Image from 'components/appImage';
import { path } from 'd3';
const BACKEND_URL = import.meta.env.VITE_API_URL;
const EmployeeNavigation = ({ user,isCollapsed = false, onToggleCollapse }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isProfileMenuOpen, setIsProfileMenuOpen] = useState(false);

  const navigationItems = [
    {
      label: 'Dashboard',
      path: '/employee-dashboard',
      icon: 'Home',
      tooltip: 'View your overview'
    },
    {
      label: 'Employee',
      path: '/employee-profile',
      icon: 'Users',
      tooltip: 'View your profile overview'
    },
    {
      label: 'Attendence',
      path: '/employee-attendance-records',
      icon: 'Home',
      tooltip: 'View your attendance overview'
    },
    // {
    //   label: 'Leave',
    //   path: '/leave-management',
    //   icon: 'Calendar',
    //   tooltip: 'Manage your leaves'
    // },
    // {
    //   label: 'salary',
    //   path: '/salary-management',
    //   icon: 'DollarSign',
    //   tooltip: 'View your salary details'
    // },
  ];


  const profileMenuItems = [
    { label: 'My Profile', icon: 'User', action: 'profile' },
    { label: 'Attendance History', icon: 'Calendar', action: 'history' },
    { label: 'Settings', icon: 'Settings', action: 'settings' },
    { label: 'Help', icon: 'HelpCircle', action: 'help' },
    { label: 'Logout', icon: 'LogOut', action: 'logout' }
  ];

  const isActivePath = (path) => location?.pathname === path;

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  const toggleProfileMenu = () => {
    setIsProfileMenuOpen(!isProfileMenuOpen);
  };

  const handleProfileAction = (action) => {
    setIsProfileMenuOpen(false);

    switch (action) {
      case 'profile': navigate('/employee-profile');
        break;
      case 'history': navigate('/attendance-records');
        break;
      case 'settings': console.log('Navigate to settings');
        break;
      case 'help': console.log('Navigate to help');
        break;
      case 'logout': navigate('/');
        break;
      default:
        break;
    }
  };

  return (
    <>
      {/* Header */}
      <header className="fixed top-0 left-0 right-0 z-50 bg-card border-b border-border enterprise-shadow-card">
        <div className="flex items-center justify-between h-16 px-6">
          {/* Logo and Brand */}
          <div className="flex items-center space-x-4">
            <button
              onClick={onToggleCollapse}
              className="hidden lg:flex items-center justify-center w-8 h-8 rounded-md hover:bg-muted enterprise-transition"
              aria-label="Toggle sidebar"
            >
              <Icon name="Menu" size={20} />
            </button>
            <button
              onClick={toggleMobileMenu}
              className="md:hidden flex items-center justify-center w-8 h-8 rounded-md hover:bg-muted enterprise-transition"
              aria-label="Toggle mobile menu"
            >
              <Icon name="Menu" size={20} />
            </button>

            <Link to="/employee-dashboard" className="flex items-center space-x-3">
              <div className="flex items-center justify-center w-8 h-8 bg-primary rounded-lg">
                <Icon name="Camera" size={20} color="white" />
              </div>
              <div className="flex flex-col">
                <span className="text-lg font-semibold text-foreground">CCTV Attendance</span>
                <span className="text-xs text-muted-foreground">Employee Portal</span>
              </div>
            </Link>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-1">
            {navigationItems?.map((item) => (
              <Link
                key={item?.path}
                to={item?.path}
                className={`flex items-center space-x-2 px-4 py-2 rounded-md text-sm font-medium enterprise-transition ${isActivePath(item?.path)
                  ? 'bg-primary text-primary-foreground'
                  : 'text-muted-foreground hover:text-foreground hover:bg-muted'
                  }`}
                title={item?.tooltip}
              >
                <Icon name={item?.icon} size={18} />
                <span>{item?.label}</span>
              </Link>
            ))}
          </nav>

          {/* User Actions */}
          <div className="flex items-center space-x-3">
            <button
              className="flex items-center justify-center w-8 h-8 rounded-md hover:bg-muted enterprise-transition"
              title="Notifications"
            >
              <Icon name="Bell" size={20} />
            </button>

            <div className="relative">
              <button
                onClick={toggleProfileMenu}
                className="flex items-center space-x-2 px-3 py-2 rounded-md hover:bg-muted enterprise-transition"
              >
                <div className="w-8 h-8 bg-primary rounded-full flex items-center justify-center">
                  <Image src={`${BACKEND_URL}${user?.image1}`} alt="User" className="w-8 h-8 rounded-full object-cover" />
                </div>
                <span className="hidden sm:block text-sm font-medium">{user?.first_name}{user?.last_name}</span>
                <Icon name="ChevronDown" size={16} />
              </button>

              {/* Profile Dropdown */}
              {isProfileMenuOpen && (
                <div className="absolute right-0 top-full mt-2 w-56 bg-popover border border-border rounded-md enterprise-shadow-modal animate-fade-in">
                  <div className="p-2">
                    <div className="px-3 py-2 border-b border-border mb-2">
                      <p className="text-sm font-medium text-foreground">{user?.first_name}{user?.last_name}</p>
                      <p className="text-xs text-muted-foreground">{user?.email}</p>
                      <p className="text-xs text-muted-foreground font-mono">{user?.employee_id}</p>
                    </div>
                    {profileMenuItems?.map((item) => (
                      <button
                        key={item?.action}
                        onClick={() => handleProfileAction(item?.action)}
                        className={`w-full flex items-center space-x-2 px-3 py-2 rounded-md text-sm enterprise-transition ${item?.action === 'logout' ? 'text-error hover:bg-error/10' : 'text-muted-foreground hover:text-foreground hover:bg-muted'
                          }`}
                      >
                        <Icon name={item?.icon} size={16} />
                        <span>{item?.label}</span>
                      </button>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </header>
      {/* Sidebar for Desktop */}
      <aside className={`fixed top-16 left-0 z-40 h-[calc(100vh-4rem)] bg-card border-r border-border enterprise-shadow-card transition-all duration-200 ease-in-out ${isCollapsed ? 'w-16' : 'w-64'
        } hidden lg:block`}>
        <div className="flex flex-col h-full p-4">
          <nav className="flex-1 space-y-2">
            {navigationItems?.map((item) => (
              <Link
                key={item?.path}
                to={item?.path}
                className={`flex items-center space-x-3 px-3 py-2 rounded-md text-sm font-medium enterprise-transition ${isActivePath(item?.path)
                  ? 'bg-primary text-primary-foreground'
                  : 'text-muted-foreground hover:text-foreground hover:bg-muted'
                  }`}
                title={isCollapsed ? item?.tooltip : ''}
              >
                <Icon name={item?.icon} size={20} />
                {!isCollapsed && <span>{item?.label}</span>}
              </Link>
            ))}
          </nav>

          {/* System Status */}
          {!isCollapsed && (
            <div className="mt-auto pt-4 border-t border-border">
              <div className="flex items-center space-x-2 px-3 py-2 text-xs text-muted-foreground">
                <div className="w-2 h-2 bg-success rounded-full"></div>
                <span>System Online</span>
              </div>
            </div>
          )}
        </div>
      </aside>
      {/* Mobile Menu Overlay */}
      {isMobileMenuOpen && (
        <div className="fixed inset-0 z-50 md:hidden">
          <div className="fixed inset-0 bg-black/50" onClick={closeMobileMenu}></div>
          <div className="fixed top-0 left-0 w-80 h-full bg-card border-r border-border animate-slide-in-from-left">
            <div className="flex items-center justify-between h-16 px-6 border-b border-border">
              <div className="flex items-center space-x-3">
                <div className="flex items-center justify-center w-8 h-8 bg-primary rounded-lg">
                  <Icon name="Camera" size={20} color="white" />
                </div>
                <div className="flex flex-col">
                  <span className="text-lg font-semibold text-foreground">CCTV Attendance</span>
                  <span className="text-xs text-muted-foreground">Employee Portal</span>
                </div>
              </div>
              <button
                onClick={closeMobileMenu}
                className="flex items-center justify-center w-8 h-8 rounded-md hover:bg-muted enterprise-transition"
              >
                <Icon name="X" size={20} />
              </button>
            </div>

            <aside className={`fixed top-16 left-0 z-40 h-[calc(100vh-4rem)] bg-card border-r border-border enterprise-shadow-card transition-all duration-200 ease-in-out ${isCollapsed ? 'w-16' : 'w-64'
              } hidden lg:block`}>
              <div className="flex flex-col h-full p-4">
                <nav className="flex-1 space-y-2">
                  {navigationItems?.map((item) => (
                    <Link
                      key={item?.path}
                      to={item?.path}
                      className={`flex items-center space-x-3 px-3 py-2 rounded-md text-sm font-medium enterprise-transition ${isActivePath(item?.path)
                        ? 'bg-primary text-primary-foreground'
                        : 'text-muted-foreground hover:text-foreground hover:bg-muted'
                        }`}
                      title={isCollapsed ? item?.tooltip : ''}
                    >
                      <Icon name={item?.icon} size={20} />
                      {!isCollapsed && <span>{item?.label}</span>}
                    </Link>
                  ))}
                </nav>

                {/* System Status */}
                {!isCollapsed && (
                  <div className="mt-auto pt-4 border-t border-border">
                    <div className="flex items-center space-x-2 px-3 py-2 text-xs text-muted-foreground">
                      <div className="w-2 h-2 bg-success rounded-full"></div>
                      <span>System Online</span>
                    </div>
                  </div>
                )}
              </div>
            </aside>

            {/* Mobile Profile Section */}
            <div className="absolute bottom-4 left-4 right-4 pt-4 border-t border-border">
              <div className="flex items-center space-x-3 px-4 py-3">
                <div className="w-10 h-10 bg-primary rounded-full flex items-center justify-center">
                  <Icon name="User" size={20} color="white" />
                </div>
                <div className="flex-1">
                  <p className="text-sm font-medium text-foreground">John Doe</p>
                  <p className="text-xs text-muted-foreground font-mono">EMP-001</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {/* Click outside to close profile menu */}
      {isProfileMenuOpen && (
        <div
          className="fixed inset-0 z-40"
          onClick={() => setIsProfileMenuOpen(false)}
        ></div>
      )}
    </>
  );
};

export default EmployeeNavigation;